export default __webpack_public_path__ + "static/media/ImgCar.b4181f75.png";